import { createFileRoute } from '@tanstack/react-router';
import { PendingSettlementsPage } from '@pages/pending-settlements';

export const Route = createFileRoute('/_authenticated/pending-settlements')({
  staticData: { hideRail: true },
  component: PendingSettlementsPage,
});
